import React from 'react';
import './spinner.css'
const Spinner = () => {
    return (
        <div className='flex flex-col items-center space-y-2'>
        <div className="custom-loader"></div>
        <p>loding..</p>
        </div>
    );
}

export default Spinner;
